import { faCheck, faPencilAlt, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Button, Form, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SkeletonItem } from '../../models/dashboard-models';
import Select from 'react-select';
import { ShortDevicePassport } from '../../models/warehouse-models';

export const MaterialsBranchTable = ({
    items,
    onMaterialChange,
    branchId,
    onMaterialAdd,
    passports,
}: {
    items: SkeletonItem[];
    branchId: number;
    onMaterialChange: (updatedBranchId: number, material: string, newQuantity?: number) => void;
    onMaterialAdd: (branchToUpdate: number, passportId: number, count: number) => void;
    passports: ShortDevicePassport[];
}) => {
    const [material, setMaterial] = useState<number | undefined>();
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const [inEditMode, setInEditMode] = useState({
        status: false,
        rowKey: 0,
    });

    const [newQuantityValue, setNewQuantityValue] = useState(1);
    const [newMaterialQuantity, setNewMaterialQuantity] = useState(1);
    const onEditClick = (index: number) => {
        setInEditMode({
            status: !(inEditMode.rowKey === index && inEditMode.status),
            rowKey: index,
        });
    };

    const [lastSelected, setLastSelected] = useState<number | undefined>();

    return (
        <div className='position-relative'>
            <Table striped hover responsive className='border-0'>
                <thead>
                    <tr>
                        <th className='fw-bold w-25'>{t('materials')}</th>
                        <th className='fw-bold w-25  text-center'>{t('quantity')}</th>
                        <th className='fw-bold w-25 text-center'>{t('actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td>{item.passportId}</td>
                            <td className='text-center'>
                                {inEditMode.status && inEditMode.rowKey === index ? (
                                    <Form.Control
                                        defaultValue={item.count || 1}
                                        min={1}
                                        type='number'
                                        placeholder={`${t('quantity')}`}
                                        onChange={(e) => {
                                            setNewQuantityValue(+e.target.value);
                                        }}
                                    />
                                ) : (
                                    item.count
                                )}
                            </td>

                            <td className='text-center'>
                                <Button
                                    type='button'
                                    size='sm'
                                    className='color-main px-1 mx-1 p-0'
                                    onClick={() => onEditClick(index)}
                                >
                                    {inEditMode.status && inEditMode.rowKey === index ? (
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            onClick={() =>
                                                onMaterialChange(branchId, item.passportId, newQuantityValue)
                                            }
                                            className='fa-fw'
                                        />
                                    ) : (
                                        <FontAwesomeIcon icon={faPencilAlt} className='fa-fw' />
                                    )}
                                </Button>

                                <Button
                                    type='button'
                                    size='sm'
                                    className='color-main px-1 mx-1 p-0'
                                    onClick={() => {
                                        onMaterialChange(branchId, item.passportId);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTrash} className='fa-fw' />
                                </Button>
                            </td>
                        </tr>
                    ))}
                    <tr className='h-100 '>
                        <td className='position-absolute w-30'>
                            <Select
                                key={lastSelected}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                options={passports}
                                getOptionValue={(option) => `${option.id}`}
                                getOptionLabel={(option) => option.name}
                                onChange={(option) => option?.id && setMaterial(option.id)}
                                maxMenuHeight={150}
                            />
                        </td>
                        <td>
                            <Form.Group controlId='formBasicEmail'>
                                <Form.Control
                                    defaultValue={1}
                                    type='number'
                                    placeholder={`${t('quantity')}`}
                                    onChange={(e) => {
                                        setNewMaterialQuantity(+e.target.value);
                                    }}
                                />
                            </Form.Group>
                        </td>
                        <td className='text-center'>
                            <Button
                                type='button'
                                disabled={!material}
                                className='color-main p-1 m-0'
                                onClick={() => {
                                    if (material) {
                                        onMaterialAdd(branchId, material, newMaterialQuantity);
                                        setLastSelected(new Date().getTime());
                                        setMaterial(undefined);
                                    }
                                }}
                            >
                                <FontAwesomeIcon icon={faPlus} className='fa-fw' />
                            </Button>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </div>
    );
};
